
import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import { updateObject } from "@/interfaces/Additional.interfaces";
import { VTextarea, VTextField } from "vuetify/lib";

export default Vue.extend({
  name: "UpdateMultipleItems",
  components: { VTextarea, VTextField },
  props: {
    item: Object,
    column: String,
    table: String,
    id: Number,
    disabled: Boolean,
    textarea: Boolean,
    displayValue: {
      default: undefined
    }
  },
  data: () => {
    return {
      currentObject: {} as updateObject
    };
  },
  computed: {
    ...mapState(["tablename", "preparedDataToSave"])
  },
  methods: {
    ...mapMutations(["modify", "callSnackbar"]),

    setData(): updateObject {
      return {
        tablename: this.table ?? this.tablename,
        column: this.column,
        columnId: this.id ?? this.item.id,
        prevValue: this.item[this.column],
        value: undefined
      };
    },

    setModify(data: Array<updateObject | null>) {
      this.modify({ property: "preparedDataToSave", value: data });
    },

    close() {
      const data = this.preparedDataToSave.filter(
        (obj: updateObject) => !(obj.value === undefined)
      );
      this.setModify(data);
    },

    cancel() {
      const data = this.preparedDataToSave.filter(
        (obj: updateObject) =>
          !(
            obj.columnId === this.currentObject.columnId &&
            obj.column === this.currentObject.column
          )
      );
      this.setModify(data);

      this.callSnackbar({
        visible: true,
        text: "Canceled",
        color: "red darken-3"
      });
    },

    save() {
      console.log(
        "🔍 UpdateMultipleItems: Saving field:",
        this.column,
        "for item:",
        this.item.id
      );
      console.log("🔍 UpdateMultipleItems: New value:", this.item[this.column]);
      this.preparedDataToSave.map((obj: updateObject) => {
        if (
          obj.columnId === this.currentObject.columnId &&
          obj.column === this.currentObject.column
        ) {
          obj.value = this.item[this.column];
        }
      });

      this.setModify(this.preparedDataToSave);

      // Automatically show the confirmation dialog when data is prepared
      this.modify({ property: "confirmDialogShow", value: true });

      this.callSnackbar({
        visible: true,
        text: "Data prepared to save",
        color: "green darken-2"
      });
    },

    open() {
      const preparedData = this.setData();
      this.currentObject = preparedData;

      if (this.preparedDataToSave.length === 0) {
        this.setModify([preparedData]);
      } else {
        const data = this.ifExistObj(this.preparedDataToSave, preparedData);
        if (!data) {
          this.setModify([...this.preparedDataToSave, preparedData]);
        } else {
          this.setModify([...this.preparedDataToSave]);
        }
      }
    },

    ifExistObj(array: Array<updateObject>, objectToAdd: updateObject) {
      let isExist = false;
      array.map((obj: updateObject) => {
        if (
          obj.columnId === objectToAdd.columnId &&
          obj.column === objectToAdd.column
        ) {
          isExist = true;
        }
      });
      return isExist;
    }
  }
});
